module.exports = __webpack_public_path__ + "img/check_vm_bg.10d9dc71.jpg";